import { PDFViewer } from '@react-pdf/renderer'
import React from 'react'
import { Modal } from 'react-bootstrap'
import CetakBastnll from '../../cetak/nonlalin/CetakBASTnll'
import CetakSTLabnll from '../../cetak/nonlalin/CetakSTLabnll'
import CetakLHPLabnll from '../../cetak/nonlalin/CetakLHPLabnll'
import CetakKuitansinll from '../../cetak/nonlalin/CetakKuitansinll'

const ModalCetakNonLalin = ({ showCetak, handleCloseCetak, dataDisposisi, datappm }) => {
    return (
        <>
            <Modal
                show={showCetak}
                onHide={handleCloseCetak}
                keyboard={false}
                size='xl'
                centered
            >
                <PDFViewer style={{ width: 1105, height: 800 }}>
                    {
                        dataDisposisi.idDisposisi === 2 &&
                        <CetakSTLabnll dataDisposisi={dataDisposisi} datappm={datappm} />
                    }
                    {
                        dataDisposisi.idDisposisi === 3 &&
                        <CetakBastnll dataDisposisi={dataDisposisi} datappm={datappm} />                        
                    }
                    {
                        dataDisposisi.idDisposisi === 4 &&
                        <CetakLHPLabnll dataDisposisi={dataDisposisi} datappm={datappm}/>
                    }
                    {
                        dataDisposisi.idDisposisi === 5 &&
                        <CetakKuitansinll dataDisposisi={dataDisposisi} datappm={datappm}/>
                    }
                </PDFViewer>
            </Modal>
        </>
    )
}

export default ModalCetakNonLalin